// @flow
import { connect } from 'react-redux'
import SegmentationItems from './SegmentationItems'
import type { Store } from '../../redux/ducks'

function mapStateToProps(state: Store) {
  const { audienceEdit, segmentation } = state
  const initial = audienceEdit.initial

  return {
    autoBids: initial && initial.priceRecommendations.autoBids,
    paymentType: audienceEdit.paymentType,
    segmentByProviders: segmentation.segmentByProviders,
    providers: audienceEdit.providers
  }
}

const SegmentationItemsContainer = connect<Object, Object, _, _, _, _>(mapStateToProps)(
  SegmentationItems
)

export default SegmentationItemsContainer
